import { Injectable, EventEmitter } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiService} from '../shared/api.service';
    
@Injectable()
export class ViewService {
    currentView;
    currentViewChange = new EventEmitter();
    views = {};
    constructor(private api: ApiService, private route: ActivatedRoute, private router: Router) {
        let userViews = this.api.getProp('views');
        if( userViews ) {
            this.views = userViews;
        }
    }
    addView(settings) {
        if( !settings.title ) return;
        let slug = this.getSlug(settings.title);
        let view = {
            filters: settings.filters,
            relation: settings.relation,
            columns: settings.columns,
            title: settings.title,
            icon: settings.icon,
            routerLink: ['/assignments'],
            queryParams: {
                view: slug
            }
        };
        this.views[slug] = view;
        this.router.navigate(['/assignments'], {
            queryParams: {
                view: slug
            }
        });
        this.saveViews();
    }
    getSuffix(suffix, slug) {
        let checkSlug = slug + '-' + suffix;
        if( this.views.hasOwnProperty(checkSlug) ) {
            suffix += 1;
            suffix = this.getSuffix(suffix, slug);
        }
        return suffix;
    }
    getSlug(title) {
        let slug = title.toLocaleLowerCase().replace(/ /g, '-');
        let suffix;
        if(this.views.hasOwnProperty(slug)) {
            suffix = this.getSuffix(1, slug);
        }
        if( suffix ) {
            slug = slug + '-' + suffix;
        }
        return slug;
    }
    saveViews() {
        let user = this.api.getProp('currentUserId');
        this.api.doAction('post', 'view', {
            data: {
                user: user,
                views: this.views
            }
        }).subscribe(
            data => {
                console.log('view saved', data);
            }
        );
    }
    setCurrentView(slug) {
        let views = this.views;
        if( views.hasOwnProperty(slug) ) {
            this.currentView = views[slug];
        } else {
            this.currentView = null;
        }
        this.currentViewChange.emit(this.currentView);
    }
    updateCurrentView(columns, filters, relation) {
        if( !this.currentView ) {
            return;
        }
        let slug = this.currentView.queryParams.view;
        this.views[slug].columns = columns;
        this.views[slug].relation = relation;
        this.views[slug].filters = filters;
        this.saveViews();
    }
    trash() {
        let view = this.route.snapshot.queryParamMap.get('view');
        if( this.views.hasOwnProperty(view) ) {
            delete this.views[view];
            this.saveViews();
        }
        this.router.navigate(['/assignments']);
    }
}
